module.exports = __webpack_public_path__ + "static/media/KM.f3f2e9ec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/KM.svg
// module id = 289
// module chunks = 0